import BackLink from 'src/components/back-link/back-link.component'
import { twMerge } from 'src/utils/tw-merge.util'

type Props = {
  title: string
  children: React.ReactNode
  subTitle?: string
  className?: string
}

export const ConfigurationHeaderWrapper = ({ title, subTitle, children, className }: Props) => {
  return (
    <div className="c-flex c-flex-col c-grow c-min-w-0">
      <div className="c-border-b c-border-grey-200 c-m-4 c-mb-0 c-pb-3 c-mt-6">
        <div className="c-flex c-items-center c-gap-4">
          <BackLink />
          <h1 className="c-text-xl c-font-nexa c-font-semibold">{title}</h1>
        </div>
        {subTitle && <p className="c-font-nexa c-text-grey-600 c-mb-0">{subTitle}</p>}
      </div>
      <main
        className={twMerge('c-p-4 c-pr-6 c-min-h-0 c-h-full c-flex c-flex-col c-overflow-auto', className)}
      >
        {children}
      </main>
    </div>
  )
}
